import firebase from "firebase";
import { useState, useEffect } from "react";
import { Quote } from "../../types/Quote";
import DB_PATH from "../DB_PATH";

const useQuotes = ({ communityId }: { communityId: string }) => {
  // CREATE a new quote
  const createQuote = async (newQuote: Quote) => {
    try {
      // Step 1: Create a document reference with an auto-generated ID
      const quoteRef = firebase.firestore().collection(DB_PATH.QUOTE).doc();

      // Step 2: Add the generated ID to newQuote and other fields (like communityId)
      const quoteWithId = { ...newQuote, id: quoteRef.id, communityId };

      // Step 3: Save the document with the added ID to Firestore
      await quoteRef.set(quoteWithId);

      return quoteRef.id;
    } catch (error) {
      console.error("Error creating new quote:", error);
      // setError(error);
    }
  };

  // UPDATE an existing quote by ID
  const updateQuote = async (id: string, updatedQuote: Partial<Quote>) => {
    try {
      await firebase
        .firestore()
        .collection(DB_PATH.QUOTE)
        .doc(id)
        .update(updatedQuote);
      console.log(`Quote with id: ${id} updated successfully`);
    } catch (error) {
      console.error("Error updating quote:", error);
      //  setError(error);
    }
  };

  // DELETE a quote by ID
  const deleteQuote = async (id: string) => {
    try {
      await firebase.firestore().collection(DB_PATH.QUOTE).doc(id).delete();
      console.log(`Quote with id: ${id} deleted successfully`);
    } catch (error) {
      console.error("Error deleting quote:", error);
      // setError(error);
    }
  };

  return {
    createQuote,
    updateQuote,
    deleteQuote,
  };
};

export default useQuotes;
